<div class="email-editor">
    <div class="email-row" *ngFor="let email of emails; let i = index; trackBy: trackByIndex">
        <div class="prepend-icon email-input">
            <input type="email"
                   class="form-control"
                   placeholder="Inserisci indirizzo email"
                   autocomplete="off"
                   [name]="'customer-email-' + i"
                   [(ngModel)]="emails[i]">
            <i class="icon-envelope"></i>
        </div>
        <button type="button"
                class="btn btn-default btn-sm email-remove"
                (click)="remove(i)"
                [disabled]="emails.length === 1"
                title="Rimuovi email"
                aria-label="Rimuovi email">
            <i class="fa fa-times"></i>
        </button>
    </div>
    <button type="button" class="btn btn-link btn-sm email-add" (click)="add()">
        <i class="fa fa-plus"></i> Aggiungi email
    </button>
</div>
